import { Link, useNavigate } from "react-router-dom"
import { URL } from "../../../../routers/constants"
import { connect } from "react-redux";
import { createCampaign, fetchCampaign, updateCampaign } from "../../../../store/action/campaignsAction";
import { useEffect, useState } from "react";
import Search from "../../../../assets/icon/svg/search";
import { formatPrice, formatTimeTxt, removeVietnameseTones } from "../../../../services/helpers/Helper";
import { fetchSettingPageInfo } from "../../../../store/action/settingPageAction";
import NoCampaign from "./no-campaign";
import Pagination from "../../../shared/components/Button/Pagination";
const _ = require('lodash');

const CampaignList = (props) => {
   const navigate = useNavigate();
   const { page, fetchCampaign, createCampaign, campaigns, updateCampaign, total } = props;
   const [search, setSearch] = useState('');

   useEffect(() => {
      if (!_.isEmpty(page)) {
         fetchCampaign();
      }
   }, [page]);

   const getData = () => {
      return campaigns.filter((f) => {
         if (!!search) {
            return removeVietnameseTones(f.campaign_name.toLowerCase()).includes(removeVietnameseTones(search.toLowerCase()));
         }
         return true;
      });
   }

   const handleOpenCampaign = (e, id) => {
      if (!e.target.closest('.closest')) {
         navigate(URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_EDIT.replace(':id', id));
      }
   }

   const handleActiveCampaign = (campaign) => {
      const data = {
         id: campaign.id,
         user_id: campaign.user_id,
         campaign_name: campaign.campaign_name,
         fb_page_id: campaign.fb_page_id,
         is_active: campaign.is_active == 1 ? 0 : 1
      }
      updateCampaign(data);
   }

   const getCampaignType = (key) => {
      switch (key) {
         case 1:
            return "Thủ công";
         case 2:
            return "Tự động";
         default:
            return "";
      }
   }

   const onChangePaginate = (page, pageSize) => {
      fetchCampaign(page, pageSize);
   }

   return (
      <div id="bot-scene-container" className="">
         {campaigns.length == 0
            ?
            <NoCampaign />
            :
            <div id="bot-scene-content" className="scroll-light">
               <div className="header-live-stream-container app-v2-header-wrapper sale-post-list-header">
                  <div className="header-live-stream-left-side">
                     <div className="header-left-side-layout">
                        <div className="header-live-stream-title-container">
                           <div className="header-live-stream-title">
                              <div className="wrapper-header-title" title="Tin bán hàng"><span
                                 className="title-header-live-stream">Tin bán hàng</span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="header-live-stream-right-side">
                     <span>
                        <Link to={URL.POSTS_COMMENTS_SALE_POSTS_SETTING}>
                           <button type="button" className="app-btn app-btn-default">
                              <div className="svg-next-icon mr5 ic-setting-two-line" >
                              </div>
                              <span>Cấu hình chung</span>
                           </button>
                        </Link>
                        <button type="button" className="app-btn app-btn-primary ml10" onClick={() => createCampaign(navigate)}>
                           <div className="svg-next-icon mr5 ic-add-outline-2" >
                           </div>
                           <span>Tạo kịch bản</span>
                        </button>
                     </span>
                  </div>
               </div>
               <div className="list-campaign-wrapper list-sale-post">
                  <div className="app-v2-table-container list-campaign-table">
                     <div>
                        <div className="app-v2-table-filter">
                           <div className="hrs-filter-container-master">
                              <div className="hrs-filter-container">
                                 {/* <div className="hrs-filter-wrapper">
                                    <div className="hrs-btn-open-filter">
                                       <div className="svg-next-icon icon-filter" >
                                       </div>
                                       <span>Bộ lọc tìm kiếm</span>
                                    </div>
                                 </div> */}
                                 <div className="hrs-filter-search-wrapper">
                                    <Search />
                                    <input className="hrs-filter-input-search" placeholder="Tên chiến dịch" value={search} onChange={(e) => setSearch(e.target.value)} />
                                 </div>
                              </div>
                              <div className="hrs-condition-container mt10"></div>
                           </div>
                        </div>
                        <div>
                           <div
                              className="app-table-container app-scrollbar has-column-fixed-right">
                              <table className="app-table app-table--vertical-middle">
                                 <thead>
                                    <tr>
                                       <th className="text-center" style={{ width: 45 }}>
                                          <span>Kích hoạt</span>
                                       </th>
                                       <th className="">
                                          <span>Chiến dịch</span>
                                       </th>
                                       <th className="" style={{ width: 128 }}>
                                          <span>
                                             Phương thức <br />chốt đơn
                                          </span>
                                       </th>
                                       <th className="text-right">
                                          <span>
                                             Tổng số <br /> bình luận
                                          </span>
                                       </th>
                                       <th className="text-right">
                                          <span>
                                             Khách có <br /> số  điện thoại
                                          </span>
                                       </th>
                                       <th className="header-with-tooltip text-right">
                                          <span>
                                             <div>
                                                Tổng số đơn <br /> tạm tính
                                             </div>
                                          </span>
                                       </th>
                                       <th className="header-with-tooltip text-right">
                                          <span>
                                             <div>Doanh thu <br /> tạm tính</div>
                                          </span>
                                       </th>
                                       <th className="text-left">
                                          <span>Thời gian cập nhật</span>
                                       </th>
                                       {/* <th className="text-center" style={{ width: 82 }}>
                                       <span>Hành <br /> động</span>
                                    </th> */}
                                    </tr>
                                 </thead>
                                 <tbody>
                                    {getData().map((item, index) => {
                                       return (
                                          <tr className="app-v2-table-row" key={index} onClick={(e) => handleOpenCampaign(e, item.id)}>
                                             <td className="text-center pointer" style={{ width: 45 }}>
                                                <div>
                                                   <button type="button" className={`app-switch ${!item.is_active ? "app-switch" : "app-switch-checked"}  app-switch-small closest`} onClick={() => handleActiveCampaign(item)}>
                                                      <span className="app-switch-inner"></span>
                                                      <div className="app-click-animating-node">
                                                      </div>
                                                   </button>
                                                </div>
                                             </td>
                                             <td className="pointer" style={{ paddingRight: 6, minWidth: 400, maxWidth: 400 }}>
                                                <div className="display-flex-align-items-center cursor-pointer">
                                                   <div className="flex-display-col min-w-0">
                                                      <p title={item.campaign_name} className="mr-reset campaign-name title-hover">
                                                         {item.campaign_name}
                                                      </p>
                                                      <span className="date-time-txt">{formatTimeTxt(item.updated_at)}</span>
                                                   </div>
                                                </div>
                                             </td>
                                             <td className="pointer" style={{ width: 128 }}><span>{getCampaignType(item.campaign_type)} </span></td>
                                             <td className="text-right pointer">{formatPrice(item.comment_total_count)}</td>
                                             <td className="text-right pointer">{formatPrice(item.customer_has_phone)}</td>
                                             <td className="text-right pointer">{formatPrice(item.orders_count)}</td>
                                             <td className="text-right pointer">
                                                <span>{formatPrice(item.revenues)} ₫</span>
                                             </td>
                                             <td className="text-left pointer">{formatTimeTxt(item.updated_at)}</td>
                                             {/* <td className="text-center pointer" style={{ width: 82 }}>
                                             <div className="action-livestream-container">
                                                <div className="copy-box closest">
                                                   <div className="svg-next-icon icon-copy-new">
                                                   </div>
                                                </div>
                                             </div>
                                          </td> */}
                                          </tr>
                                       )
                                    })}
                                 </tbody>
                              </table>
                           </div>
                        </div>
                        <div className="app-v2-table-footer-wrapper">
                           <div className="">
                              <Pagination
                                 total={total}
                                 onChange={onChangePaginate}
                              />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         }
      </div>
   )
}

const mapStateToProps = (state) => {
   const { campaigns, page } = state;

   return {
      campaigns: _.isArray(campaigns?.items) ? campaigns?.items : [],
      total: _.isInteger(campaigns.total) ? campaigns.total : 0,
      page,
   };
};

export default connect(mapStateToProps, {
   createCampaign,
   fetchCampaign,
   updateCampaign,
   fetchSettingPageInfo
})(CampaignList)